import * as React from 'react';
import {IProduct, IQuantity} from "../../functions/Interfaces";
import { Button, Typography, IconButton } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import '../basket/Basket.css';
import { setHapticFeedback} from '../../functions/WebbridgeFunctions';
// import {
//   Link,
// } from "react-router-dom";
 
class Wishlist extends React.Component<any,{ products: IProduct[]; quantity: IQuantity[] }> {
  public render() {
    const size: number = this.props.size;
    const products: IProduct[] = this.props.products;
    const quantity: IQuantity[] = this.props.quantity;
    const rows: any = [];

    products.forEach((product: IProduct) => {
      let elemQuantity: IQuantity = { id: "0", quantity: 0 };
      const dummyQuantity: any = quantity.find(item => item.id === product.id);
      if (dummyQuantity !== undefined) {
        elemQuantity = dummyQuantity;
      }
      rows.push(
        <tr key={product.id}>
          <td>
            <div className="imgDiv">
              <a href={ process.env.PUBLIC_URL + "/p/" + product.id} 
               onClick={e => this.props.actionUp()}> 
                <img
                  alt={product.name}
                  className="img-basket"
                  src={product.picture}
                />
              </a>
            </div>
          </td>
          <td>{product.name}</td>
          <td>{product.price}€</td>
          <td className="Tablequantity">{elemQuantity.quantity}</td>
          <td>
            <IconButton
              aria-label="delete"
              color="primary"
              onClick={e => this.props.actionDelete(product)}
            >
              <DeleteIcon />
            </IconButton>
          </td>
        </tr>
      );
    });
    return (
      <div className="Wishlist-All">
        <Typography color="primary" align="center" variant="h2">
          Wishlist
        </Typography>
        <p> Which products do you like?</p>
        <p> In the wishlist are {size} products </p>
        <Button
          variant="contained"
          color="primary"
          onClick={e => {this.props.actionClear(), setHapticFeedback("light")}}
          className="Buttons"
        >
          Clear Wishlist
        </Button>
        {products.length >= 1 ? (
        <div className="Basket-Table">
          <table>
            <thead/>
              <tbody>
                <tr key="Title">
                  <td>Article</td>
                  <td/>
                  <td>Price</td>
                  <td>Amount</td>
                </tr>
                {rows}
            </tbody>
          </table>
        </div>
    ) : (null)}
      </div>
    );
  }
}
export default Wishlist;


// WEBPACK FOOTER //
// ./src/components/wishlist/Wishlist.tsx